import React from "react";

import { InitPreviewSocialLogos, PreviewSocialNetworks } from "@/features/previews/shared";
import type { CouponSocialSectionProps } from "./types";

export const CouponSocialSection = ({ data, isInitialPreview }: CouponSocialSectionProps) => {
  if ((data?.socialNetworks?.length ?? 0) > 0) {
    return (
      <PreviewSocialNetworks
        networks={data.socialNetworks}
        variant="coupon"
        className="coupon-template__social-networks"
      />
    );
  }

  if (isInitialPreview) {
    return (
      <InitPreviewSocialLogos
        type="coupon"
        socialLogos={data?.socialLogos}
        className="coupon-template__social-logos"
        themeColor={data?.themeColor}
      />
    );
  }

  return null;
};
